import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { isChannel } from "@website/utils/channel/helpers";
import { deepCompare } from "@website/utils/deep-compare";
import { AccommodationBannerPropertiesTypes } from "@website/widget/accommodation-banner/accommodation-banner.types";
import { memo } from "react";

const Component = (properties: AccommodationBannerPropertiesTypes) => {
  const { onclick, cityTitle } = properties;

  if (isChannel(["ads"])) return null;

  return (
    <div className="border-primary bg-transparent-primary flex w-full flex-col justify-between gap-3 rounded-xl border px-4 py-3 md:flex-row md:items-center">
      <div>
        <div className="flex flex-row items-center gap-2">
          <MaterialIcon className="text-primary text-headline-5" name="home" />
          <span className="text-subtitle-2">{`هنوز هتل مناسب تو ${cityTitle} پیدا نکردی؟`}</span>
        </div>
        <span className="text-caption">
          ویلاهای با امکانات کامل و قیمت مناسب رو هم می‌تونی بررسی کنی!
        </span>
      </div>
      <Button
        className="self-end"
        onClick={onclick}
        text={`مشاهده ویلاهای ${cityTitle}`}
      />
    </div>
  );
};

export const AccommodationBanner = memo(Component, deepCompare);
